import React, { Suspense, lazy } from 'react';
//css and images
import './ProductDetailCustomText.scss';

import {connect} from 'react-redux';
//import Select from 'react-select';
import TextareaAutosize from 'react-autosize-textarea';
import fonts from '../../data/fonts';

import {goPreviewPage, setCustomTextProps, setElementProperty,} from '../../actions';

const colorCodes = ['#CF0072', '#AA9C8F', '#1E1E1E', '#8E258D', '#002395', '#747678', '#BED600', '#997A8D', '#B82011',
    '#29A697', '#318CE7', '#0173A9', '#D486A8', '#F7F7F7'];

const Select = lazy(() => import('react-select'));

class ProductDetailCustomText extends React.Component {
    _isMounted = false;

    constructor(props, context) {
        super(props, context);
        this.state = {
            textElements: props.textElements,
            changes: {},
            activeHash: null,
        };
    }

    changeFont(hash, selectedOption) { // {value: "chocolate", label: "Chocolate"}
        const value = selectedOption ? selectedOption.value : null;
        //let textElements = this.state.textElements;
        //textElements[hash] = {...this.state.textElements[hash], textContent: value?value:this.state.textElements[hash].textContent};

        let changes = {...this.state.changes};
        if (!changes[hash]) {
            changes[hash] = {};
        }
        if (value) {
            changes[hash].textFontFamily = value;
        } else {
            delete changes[hash].textFontFamily;
        }
        this.setState({
            changes
        }, () => (setTimeout(this.props.setCustomTextProps.bind(this, hash, {textFontFamily: value ? value : this.state.textElements[hash].textFontFamily}), 50)));

    }

    changeFontColor(hash, colorCode, event) {
        if (event) {
            event.preventDefault();
        }
        //console.log(hash, colorCode);

        const value = colorCode;
        //let textElements = this.state.textElements;
        //textElements[hash] = {...this.state.textElements[hash], textContent: value?value:this.state.textElements[hash].textContent};

        let changes = {...this.state.changes};
        if (!changes[hash]) {
            changes[hash] = {};
        }
        if (value) {
            // changes[hash].textColor = value;
            this.setState({
                changes: {
                    ...changes,
                    [hash]: {
                        ...this.state.changes[hash], textColor: value
                    }
                }
            }, () => (setTimeout(this.props.setCustomTextProps.bind(this, hash, {textColor: value ? value : (this.state.textElements[hash].textColor ? this.state.textElements[hash].textColor : '#000000')}), 50)));
        } else {
            delete changes[hash].textColor;
            // console.log('changeFontColor tobe', value, changes)
            this.setState({
                changes
            }, () => (setTimeout(this.props.setCustomTextProps.bind(this, hash, {textColor: value ? value : (this.state.textElements[hash].textColor ? this.state.textElements[hash].textColor : '#000000')}), 50)));
        }

    }

    changeSvgColor(hash, colorCode, colorMap) {

        this.props.setCustomTextProps(hash,
            {
                photoUrl: this.props.WovenElements[hash].photoUrl.replace(/%22%3A%22%23[a-f0-9]{3,6}/i, '%22%3A%22' + encodeURIComponent(colorCode)),
                colorMap: {...this.props.WovenElements[hash].colorMap, ...colorMap},
            }
        )

    }

    handleInput(event) {
        let txtValue = event.target.value;
        const re = new RegExp('(\\p{Emoji}\\uFE0F|\\p{Emoji_Modifier_Base}\\p{Emoji_Modifier}?|\\p{Emoji_Presentation})', 'u');
        if (re.test(txtValue)) {
            event.target.value = txtValue.replace(re, '');
        }
    }

    handleChange(hash, event) {
        let value = event.target.value;
        //let textElements = this.state.textElements;
        //textElements[hash] = {...this.state.textElements[hash], textContent: value?value:this.state.textElements[hash].textContent};

        const re = new RegExp('(\\p{Emoji}\\uFE0F|\\p{Emoji_Modifier_Base}\\p{Emoji_Modifier}?|\\p{Emoji_Presentation})', 'u');
        if (re.test(value)) {
            alert('Sorry, we\'re not support emoji yet');

            value = value.replace(re, '');
        }

        let change = {};
        if (this.state.changes[hash]) {
            change = {...this.state.changes[hash]}
        }
        if (value) {
            change.textContent = value;
        } else {
            delete change.textContent;
        }
        const changes = {...this.state.changes};
        changes[hash] = {...change};
        this.setState({
            changes: {...changes}
        }, () => (
            this.processing = setTimeout(this.props.setCustomTextProps.bind(this, hash, {textContent: value ? value : this.state.textElements[hash].textContent}), 50)
        ));

        return true;
    }

    activateHash(hash) {
        if (hash) {
            this.setState({
                activeHash: hash
            });
            this.props.goPreviewPage(this.props.textElements[hash].pageNumber)
        }
    }

    /*componentWillReceiveProps(props) {
        if(JSON.stringify(this.props.currentDesignBackground)!=JSON.stringify(props.currentDesignBackground))
        this.setState({
            textElements: props.textElements
        });
    }*/

    componentDidMount() {
        this._isMounted = true;
        window.setTimeout(() => {
            if (this._isMounted)
            {
                this.forceUpdate();
            }
        }, 1000)
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    shouldComponentUpdate(nextProps, nextState) {
        // if (nextProps.editMode == this.props.editMode && this.props.editMode == 'text') return false;
        if (//JSON.stringify(this.props.textElements) !== JSON.stringify(nextProps.textElements) ||
            JSON.stringify(this.state.changes) !== JSON.stringify(nextState.changes) ||
            this.state.activeHash !== nextState.activeHash
        ) {
            // console.log('should update', {textelemetsProps:this.props.textElements, nextState})
            return true;
        }
        if (-1 !== [58, 59, 60].indexOf(this.props.productId) && JSON.stringify(this.props.currentProjectOptions) !== JSON.stringify(nextProps.currentProjectOptions)) {
            return true;
        }
        return false;
    }


    render() {
        //console.log('rerendering', this.props.currentProjectOptions);
        let hashes = Object.keys(this.props.textElements);
        const SelectedOptions = {
            'Baskerville': {value: 'Baskerville', label: 'Baskerville'},
            'TheHistoriaDemo': {value: 'TheHistoriaDemo', label: 'TheHistoriaDemo'},
            'AlternateGotNo2D': {value: 'AlternateGotNo2D', label: 'AlternateGotNo2D'}
        };

        let colorOptions = colorCodes;
        if (-1 !== [58, 59, 60].indexOf(this.props.productId)) {
            // console.log(this.props.productId, this.props.currentProjectOptions)
            switch (this.props.currentProjectOptions['tape_color']) {
                // @todo reset the selected value if not found in these options
                case 'cream' :
                    colorOptions = [
                        '#000000',
                        '#B1221B',
                        '#042A8D',
                        '#36684A',
                        '#754C24',
                        '#C080A5',
                        '#FBCA28',
                    ];
                    break;
                case 'storm' :
                case 'pink' :
                    colorOptions = [
                        '#000000',
                        '#FFFFFF',
                    ];
                    break;
                case 'white' :
                    if (this.props.productId == 58) {
                        colorOptions = [
                            '#000000',
                            '#B1221B',
                            '#042A8D',
                            '#36684A',
                            // '#C080A5',
                            // '#FBCA28',
                            '#DADADB',
                        ]
                    } else {
                        colorOptions = [
                            '#000000',
                            '#B1221B',
                            '#042A8D',
                            '#36684A',
                            '#C080A5',
                            '#FBCA28',
                            '#DADADB',
                        ]
                    }
                    break;
                case 'navyblue' :
                    colorOptions = [
                        '#FFFFFF',
                        '#B1221B',
                        '#C080A5',
                        '#FBCA28',
                        '#DADADB',
                    ];
                    break;
                case 'black' :
                    colorOptions = [
                        '#FFFFFF',
                        '#B1221B',
                        '#36684A',
                        '#C080A5',
                        '#C080A5',
                        '#FBCA28',
                        '#DADADB',
                    ];
                    break;
                case 'green' :
                    colorOptions = [
                        '#FFFFFF',
                        '#B1221B',
                        '#C080A5',
                        '#FBCA28',
                    ];
                    break;
            }

            Object.keys(this.props.WovenElements).map((hash) => {
                if (this.props.WovenElements[hash].type === 'text') {
                    let color = this.state.changes[hash] && this.state.changes[hash].textColor ? this.state.changes[hash].textColor : this.state.textElements[hash].textColor ? this.state.textElements[hash].textColor : '#000000';
                    if (-1 === colorOptions.indexOf(color)) {
                        this.changeFontColor(hash, colorOptions[0]);
                    }
                } else if (this.props.WovenElements[hash].colorMap && this.props.WovenElements[hash].photoUrl) {

                    let colorMap = {};
                    for (let originalColor in this.props.WovenElements[hash].colorMap) {
                        if (this.props.WovenElements[hash].colorMap[originalColor][0] === '#') {
                            colorMap[originalColor] = this.props.WovenElements[hash].colorMap[originalColor];
                            break;
                        }
                    }

                    let originalColor = Object.keys(colorMap)[0];
                    if (-1 === colorOptions.indexOf(originalColor)) {
                        let newColorMap = {};
                        //console.log({colorMap, originalColor}, colorOptions[0], this.props.WovenElements[hash].colorMap)
                        newColorMap[originalColor] = colorOptions[0];
                        this.changeSvgColor(hash, colorOptions[0], newColorMap);
                    }
                }
            })
        }


        const CollectFonts = {};
        hashes.map(hash => {
            CollectFonts[this.props.textElements[hash].textFontFamily] = true;
        });

        let options = [];
        const OriginalFonts = {};
        let found = false;
        fonts.engFonts.filter(font => !!font.img).map(font => {
            if (SelectedOptions.length <= options.length && CollectFonts.length <= OriginalFonts.length) {
                return;
            }
            if (SelectedOptions[font.value]) {
                options.push({
                    value: font.value,
                    label: <img src={font.img}/>,//font.label,
                    img: font.img
                });
                found = true;
            }
            if (CollectFonts[font.value]) {
                OriginalFonts[font.value] = <img src={font.img}/>
            }
        });

        if (!found) {
            fonts.otherFonts.filter(font => !!font.img).map(font => {
                if (SelectedOptions.length <= options.length && CollectFonts.length <= OriginalFonts.length) {
                    return;
                }
                if (SelectedOptions[font.value]) {
                    options.push({
                        value: font.value,
                        label: <img src={font.img}/>,//font.label,
                        img: font.img
                    })
                }
                if (CollectFonts[font.value]) {
                    OriginalFonts[font.value] = <img src={font.img}/>
                }
            });
        }


        return (<div>
            {(this.state.textElements && hashes.length) ? (
                hashes.map((hash, index) => {
                        return (
                            <React.Fragment key={hash}>
                                <div className="row">
                                    <div
                                        className="col-3 h6 font-weight-bold mt-2 d-none d-sm-block">{index ? ' ' : 'Personalise'}</div>
                                    <div className="col-3 h6 font-weight-bold mt-2 d-sm-none">{index ? ' ' : 'Texts'}</div>
                                    <div className="col-9 justify-content-end">
                                        <div key={"custom-text-input-" + hash} className="input-group mb-2">
                                            <TextareaAutosize autoComplete="off" autoCorrect="off" autoCapitalize="off"
                                                              spellCheck="off"
                                                              maxLength={this.state.textElements[hash].singleLine ? (this.state.textElements[hash].maxChar ? this.state.textElements[hash].maxChar : 25) : null}
                                                              className="form-control pl-0 rounded-0 pb-0"
                                                              placeholder={this.state.textElements[hash].textContent}
                                                              value={this.state.changes[hash] && undefined !== this.state.changes[hash].textContent ? this.state.changes[hash].textContent : ''}
                                                              onChange={this.handleChange.bind(this, hash)}
                                                              onFocus={this.activateHash.bind(this, hash)}
                                                              onInput={this.handleInput.bind(this)}
                                            />

                                        </div>
                                    </div>
                                    {hash == this.state.activeHash ? null :
                                        <div className="w-100 d-block border-top mt-2">&nbsp;</div>}
                                </div>
                                {hash === this.state.activeHash ? <Suspense fallback={<div></div>}><div className="row">
                                    <div className="col-3 h6 font-weight-bold mt-1"></div>
                                    {-1 === [58, 59, 60].indexOf(this.props.productId) ?
                                        <div className="col-lg-7 col-6 justify-content-end pr-0">
                                            <Select
                                                onFocus={this.props.goPreviewPage.bind(this, this.props.textElements[hash].pageNumber)}
                                                options={options} isClearable={true}
                                                onChange={this.changeFont.bind(this, hash)}
                                                isSearchable={false}
                                                placeholder={OriginalFonts[this.props.textElements[hash].textFontFamily] ? OriginalFonts[this.props.textElements[hash].textFontFamily] : this.props.textElements[hash].textFontFamily}></Select>
                                        </div> : ''
                                    }
                                    <div className="col pr-0">
                                        <div className="btn-group" role="group"
                                             aria-label="Button group with nested dropdown">
                                            <button
                                                onFocus={this.props.goPreviewPage.bind(this, this.props.textElements[hash].pageNumber)}
                                                id={'custom-text-color-' + hash} type="button"
                                                className="btn btn-outline-dark dropdown-toggle b-original"
                                                style={{'minWidth': '55px'}} data-toggle="dropdown" aria-haspopup="true"
                                                aria-expanded="false">
                                                <div className="border d-inline-block" style={{
                                                    'background': this.state.changes[hash] && this.state.changes[hash].textColor ? this.state.changes[hash].textColor : this.state.textElements[hash].textColor ? this.state.textElements[hash].textColor : 'black',
                                                    'width': '85%'
                                                }}>&nbsp;</div>
                                            </button>
                                            <div className="dropdown-menu color-picker py-1 pl-3 dropdown-menu-right"
                                                 aria-labelledby={'custom-text-color-' + hash}>
                                                <span className="dropdown-menu-arrow"/>
                                                <div className="row mx-0">
                                                    {
                                                        colorOptions.map((colorCode, index) => (
                                                            <a key={index} className="col-1 py-2 flex-item" href="#"
                                                               onClick={this.changeFontColor.bind(this, hash, colorCode)}>
                                                                <div className="border"
                                                                     style={{'background': colorCode}}>&nbsp;</div>
                                                            </a>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-100 d-block border-top mt-2">&nbsp;</div>
                                </div></Suspense> : null}
                            </React.Fragment>
                        )
                    }
                )) : ""}
        </div>)
    }
}

const mapStateToProps = state => {
    let currentDesignBackground = null;
    if (state.projectOptions && state.projectOptions.images) {
        if (state.currentProjectOptions && !Object.keys(state.currentProjectOptions).length && state.projectOptions.images.length) {
            currentDesignBackground = state.projectOptions.images[0];
        } else if (state.currentProjectOptions && state.projectOptions.images) {
            let matchIndex = state.projectOptions.images.map(image => {
                let match = 0;
                for (let option in state.currentProjectOptions) {
                    if (image[option] === state.currentProjectOptions[option]) {
                        match = match + 1;
                    }
                }
                return match;
            });

            var max = Math.max.apply(null, matchIndex);
            currentDesignBackground = state.projectOptions.images[matchIndex.findIndex(matchCount => matchCount === max)];
        }

    }

    // let previewPage = 0;
    // if (currentDesignBackground && currentDesignBackground.previews && state.previewPage && currentDesignBackground.previews[state.previewPage]) {
    //   previewPage = state.previewPage
    // }

    let previewIdx = {}
    if (currentDesignBackground)
        for (let index in currentDesignBackground.previews) {
            let preview = currentDesignBackground.previews[index];
            if (preview.design_page && !previewIdx[preview.design_page]) {
                previewIdx[preview.design_page] = index;
            }
        }

    let textElements = {};
    let WovenElements = {};

    // let designPage = 0;
    // if (currentDesignBackground && currentDesignBackground.previews && currentDesignBackground.previews[state.previewPage]) {
    //     designPage = parseInt(currentDesignBackground.previews[state.previewPage].design_page);
    // }
    var pageNumber;
    for (pageNumber in state.pages) {
        let page = state.pages[pageNumber];
        for (let element of page.elements) {
            if (element.type === 'text') {
                let newElement = JSON.parse(JSON.stringify(element));
                if (state.pages.length > 2) {
                    newElement.pageNumber = previewIdx[pageNumber.toString()] ? previewIdx[pageNumber.toString()] : pageNumber;
                } else {
                    newElement.pageNumber = pageNumber;
                }
                if (state.customTexts && state.customTexts[element.hash] && state.customTexts[element.hash].textContent) {
                    newElement = {...newElement, ...state.customTexts[element.hash]}
                }
                newElement = (({type, textContent, hash, singleLine, maxChar, pageNumber, textColor, textFontFamily}) => ({
                    type,
                    textContent,
                    hash,
                    singleLine,
                    maxChar,
                    pageNumber,
                    textColor,
                    textFontFamily
                }))(newElement);
                textElements[element.hash] = WovenElements[element.hash] = newElement;
            } else if (element.type === 'graphic') {
                let newElement = JSON.parse(JSON.stringify(element));
                if (state.customTexts && state.customTexts[element.hash] && state.customTexts[element.hash].textContent) {
                    newElement = {...newElement, ...state.customTexts[element.hash]}
                }
                newElement = (({type, photoUrl, hash, colorMap}) => ({type, photoUrl, hash, colorMap}))(newElement);
                WovenElements[element.hash] = newElement;
            }
        }
    }


    return {
        textElements,
        WovenElements,
        //pages: state.pages,
        currentDesignBackground: currentDesignBackground,
        //previewPage: previewPage,
        //customTexts: state.customTexts,
        currentProjectOptions: state.currentProjectOptions,
        productId: state.productId,
    };
};

const mapDispatchToProps = dispatch => ({
    goPreviewPage: (page) => dispatch(goPreviewPage(page)),
    setElementProperty: (elementHash, changes) => dispatch(setElementProperty(elementHash, changes)),
    //setCustomText: (elementHash, newText) => dispatch(setCustomText(elementHash, newText)),
    setCustomTextProps: (elementHash, newText) => dispatch(setCustomTextProps(elementHash, newText)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetailCustomText);
